import { useLocation } from "@reach/router"
import useSubdomain from "./useSubdomain"

// non-production hosts
const DEV_HOSTS = ["preview", "development", "localhost"]

/**
 * Whether the current host should display as the main promotional site. Returns
 * true for www.wingspans.com, and for non-production branchs without a hard-coded
 * subdomain.
 * @returns {boolean}
 */
const useIsMainSite = () => {
  const location = useLocation()
  const { subdomain } = useSubdomain()

  const leftmostSubdomain = location?.hostname?.split(".")[0] || "www"
  return leftmostSubdomain === "www" || (DEV_HOSTS.includes(leftmostSubdomain) && !subdomain)
}

export default useIsMainSite
